module.exports = __webpack_public_path__ + "img/mercedes.bfd27747.jpg";